<template>
    <v-container class="contenedor-principal mt-6 ancho-limitado">
        <v-row no-gutters>
            <v-col cols="12">
                <p class="display-1">{{$t('metodologia')}}</p>
                <p class="headline pb-6">{{$t('metodologia_d')}}</p>
            </v-col>
        </v-row>
        <v-row no-gutters :class="['text-lg-center', 'bloques', {'md': $vuetify.breakpoint.md}]">
            <v-col cols="12" md="4" class="pr-4">
                <v-img :src="require('../../assets/iconos/herramienta_innovadora.png')" contain height="70"></v-img>
                <p class="title">{{$t('herramienta')}}</p>
                <p class="subtitle-1">{{$t('herramienta_d')}}</p>
            </v-col>
            <v-col cols="12" md="4" class="pr-2 pl-2">
                <v-img :src="require('../../assets/iconos/prespectiva_ciclo.png')" contain height="70"></v-img>
                <p class="title">{{$t('perspectiva')}}</p>
                <p class="subtitle-1">{{$t('perspectiva_d')}}</p>
            </v-col>
            <v-col cols="12" md="4" class="pl-4">
                <v-img :src="require('../../assets/iconos/reglamento.png')" contain height="70"></v-img>
                <p class="title">{{$t('reglamento')}}</p>
                <p class="subtitle-1">{{$t('reglamento_d')}}</p>
            </v-col>
        </v-row>

        <v-row no-gutters class="mt-12">
            <v-col cols="12">
                <p class="display-1">{{$t('funcionalidades')}}</p>
                <p class="headline pb-6">{{$t('funcionalidades_d')}}</p>
            </v-col>
        </v-row>
        <v-row no-gutters :class="['text-lg-center', 'bloques', {'md': $vuetify.breakpoint.md}]">
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/materiales.png')" contain height="70"></v-img>
                <p class="title">{{$t('mat_sol')}}</p>
                <p class="subtitle-1">{{$t('mat_sol_d')}}</p>
            </v-col>
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/personalizacion.png')" contain height="70"></v-img>
                <p class="title">{{$t('escenario')}}</p>
                <p class="subtitle-1">{{$t('escenario_d')}}</p>
            </v-col>
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/informacion.png')" contain height="70"></v-img>
                <p class="title">{{$t('info')}}</p>
                <p class="subtitle-1">{{$t('info_d')}}</p>
            </v-col>
        </v-row>
        <v-row no-gutters :class="['text-lg-center', 'bloques', {'md': $vuetify.breakpoint.md}]">
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/descarga.png')" contain height="70"></v-img>
                <p class="title">{{$t('descargas')}}</p>
                <p class="subtitle-1">{{$t('descargas_d')}}</p>
            </v-col>
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/area_personal.png')" contain height="70"></v-img>
                <p class="title">{{$t('personal')}}</p>
                <p class="subtitle-1">{{$t('personal_d')}}</p>
            </v-col>
            <v-col cols="12" md="4">
                <v-img :src="require('../../assets/iconos/biblioteca.png')" contain height="70"></v-img>
                <p class="title">{{$t('biblioteca')}}</p>
                <p class="subtitle-1">{{$t('biblioteca_d')}}</p>
            </v-col>
        </v-row>

        <v-row no-gutters class="mb-6 mt-6">
            <v-col cols="12">
                <p class="display-1">{{$t('equipo')}}</p>
                <p class="headline pb-6">{{$t('equipo_d')}}</p>
            </v-col>
        </v-row>

        <v-row no-gutters :class="['text-lg-center', 'bloques', 'pb-12', 'mb-12',{'md': $vuetify.breakpoint.md}]">
            <v-col cols="12" md="6">
                <b>{{$t('financiacion')}}</b><br>
                {{$t('diputacion')}}<br>
                <a href="https://www.dipcas.es" target="_blank">https://www.dipcas.es</a><br><br>

                <b>{{$t('idea_or')}}</b><br>
                José Luis Porcar<br>
                {{$t('instituto')}}<br>
                <a href="http://www.ipc.org.es" target="_blank">www.ipc.org.es</a><br><br>

                <b>{{$t('desarrollo')}}</b><br>
                {{$t('instituto_itc')}}<br>
                <a href="http://www.itc.uji.es" target="_blank">http://www.itc.uji.es</a><br>
            </v-col>
            <v-col cols="12" md="6">
                <div v-html="$t('indi_eco')"></div><br>
                <div v-html="$t('indi_amb')"></div><br>
                <div v-html="$t('indi_pres')"></div><br><br>

                <b>{{$t('programacion')}}</b><br>
                SiGO<br>
                <a href="http://www.sigogestion.com" target="_blank">http://www.sigogestion.com</a><br><br>

                <b>{{$t('disenyo_web')}}</b><br>
                Joan Rojeski Studio<br>
                <a href="http://www.joanrojeski.com/" target="_blank">http://www.joanrojeski.com/</a><br>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: 'InfoPagina',
        components: {},
        data: () => ({
            //
        }),
    };
</script>

<style lang="scss" scoped>

    .contenedor-principal {
        /*padding: 0;*/
        color: #40108e;
    }

    .display-1 {
        font-weight: bolder !important;
    }

    .headline {
        font-size: 2.1rem !important;
        font-weight: lighter !important;

    }

    .bloques {

        text-align: center !important;

        .v-image {
            margin: 20px;
        }

        .title {
            font-weight: bolder;
        }

        &.md {
            .title {
                min-height: 4rem;
            }
        }
    }
</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "metodologia": "METODOLOGÍA",
    "metodologia_d": "Seguida para la evaluación de las soluciones constructivas",
    "herramienta": "HERRAMIENTA INNOVADORA",
    "herramienta_d": "Solconcer utiliza un enfoque innovador para la evaluación de soluciones constructivas y materiales de revestimiento, que combina aspectos ambientales, económicos y prestacionales.",
    "perspectiva": "PERSPECTIVA DE CICLO DE VIDA",
    "perspectiva_d": "Este enfoque está basado en el Análisis de Ciclo de Vida (ACV) de los materiales. El ACV está considerado como uno de los mejores métodos para evaluar los impactos, ambientales y económicos, asociados a los productos.",
    "reglamento": "EXIGENCIAS TÉCNICAS",
    "reglamento_d": "Evaluación prestacional basada en los requisitos de los Documentos de Evaluación Europeos exigidos a las soluciones constructivas y en los requisitos esenciales de la obra del Reglamento Europeo de Productos de la Construcción",
    "funcionalidades": "FUNCIONALIDADES",
    "funcionalidades_d": "Todo lo que Solconcer te ofrece",
    "mat_sol":"SOLUCIONES CONSTRUCTIVAS",
    "mat_sol_d":"Gran variedad de materiales de recubrimiento y soluciones constructivas disponibles para su evaluación.",
    "escenario":"PERSONALIZACIÓN ESCENARIOS",
    "escenario_d":"Personaliza los datos de partida y analiza los resultados en función de los diferentes escenarios propuestos.",
    "info":"OBTENCIÓN DE INFORMACIÓN",
    "info_d":"Gran recopilación de datos sobre numerosos materiales de pavimentos y revestimientos.",
    "descargas":"DESCARGA DE INFORMES",
    "descargas_d":"Documentos donde queda refleja toda la información sobre la metodología e hipótesis adoptadas en el cálculo.",
    "personal":"ÁREA PERSONAL",
    "personal_d":"Registrándose el usuario puede guardar las evaluaciones realizadas y acceder a ellas través del área privada.",
    "biblioteca":"BIBLIOTECA DE PRODUCTOS",
    "biblioteca_d":"En el área personal el usuario puede crear materiales de revestimiento, completamente personalizables, para su posterior evaluación.",
    "equipo":"EQUIPO DE DESARROLLO",
    "equipo_d":"Quién hace posible este proyecto",
    "financiacion":"FINANCIACIÓN",
    "diputacion":"Diputación de Castellón",
    "idea_or":"IDEA ORIGINAL",
    "instituto":"Instituto de Promoción Cerámica. Diputación de Castellón",
    "instituto_itc":"Instituto de Tecnología Cerámica (AICE-ITC-UJI)",
    "desarrollo":"DESARROLLO Y COORDINACIÓN",
    "programacion":"PROGRAMACIÓN",
    "disenyo_web":"DISEÑO WEB",
    "indi_eco": "<b>Indicadores económicos + Coordinación:</b><br>Javier Mira, Jorge Corrales, Laura Vilalta",
    "indi_amb": "<b>Indicadores ambientales:</b><br>Teresa Ros, Irina Celades",
    "indi_pres": "<b>Indicadores prestacionales:</b><br>Adoración Muñoz, Alfredo Beltrán"
    }
    }
</i18n>
<!--@formatter:on-->
